/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2020, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore',
	'jquery',
	'../../../widgets/livewidget/nls/StringResources',
	'../../../util/JumpToActionHelper',
	'react-dom',
	'react',
	'@ba/ba-ui-carbon-toolkit',
	'prop-types'
], function (_, $, StringResources,JumpToActionHelper, ReactDOM, React, Toolkit, PropTypes) {

	const { Container, TruncatedText, List } = Toolkit;

	class JumpToViewComponents extends React.Component {

		constructor(props) {
			super(props);
			this.state = {
				targets: []
			};
			this.jumpToTargets = props.jumpToTargets;

		}

		componentDidMount() {
			this._getData();
		}

		_processData(items){
			if (items.length === 0) {
				this._addNewTargetItem(items);
			} else {
				_.each(items, function(item) {
					item.isTarget = true;
				});

				//Add manage to this list of items
				//check if the 'Manage...' item has already been added to the items array.
				let manageIndex = items.findIndex(item => item.isManage === true);
				if (manageIndex === -1){
					this._addManageItem(items);
				}
			}

			if (items.length > 0) {
				items[items.length - 1].hideDivider = true;
			}
			this.setState({ targets: items });
		}

		_getData(){
			return this.props.dashboard.getDashboardSvc('DrillThroughService')
				.then( (drillThroughService) => {
					return drillThroughService.getDrillThroughModelApi()
						.then( (dtModelApi) => this._getJumpToTargets(dtModelApi))
						.then( (targets) => this._processData(targets));
				});
		}

		_addNewTargetItem(items) {
			if (!this._isDataPointSelection() && this._getAuthoringMode()) {
				items.push( {
					addNewTarget: true,
					getId: function() { return 'addNewTarget'; },
					getName: function() {
						return StringResources.get('drillthrough_addNewTarget');
					}
				});
			}
		}

		_getAuthoringMode(){
			return this.props.dashboard.getMode() === 'authoring';
		}

		_addManageItem(items) {
			if (!this._isDataPointSelection() && this._getAuthoringMode()) {
				items.push( {
					isManage: true,
					getId: function() { return 'manage'; },
					getName: function() {
						return StringResources.get('drillthrough_manage');
					}
				});
			}
		}

		_getJumpToTargets(dtModelApi) {
			if (this.jumpToTargets) {
				return Promise.resolve(this.jumpToTargets.targets);
			} else {
				const entries = dtModelApi.getDrillDefinitionEntries(this.props.content);
				this.jumpToTargets = JumpToActionHelper.getJumpToTargets( {
					dashboardApi: this.props.dashboard,
					content: this.props.content,
					drillDefinitions: entries,
					selections: undefined,
					sourceId: this.props.sourceId
				} );
				return Promise.resolve(this.jumpToTargets.targets);
			}
		}

		_isDataPointSelection() {
			return this.props.isDataPointSelection;
		}

		_itemRenderer(index) {
			const item = this.state.targets[index];
			const name = item.getName();
			let className = 'visJumpToView-item';
			className = item.hideDivider ? `${className}  hide-bottom-divider`: className;
			className = item.isTarget ? `${className} drillToTarget`:className;
			className = item.isManage ? `${className} manageDrillThrough`:className;
			className = item.addNewTarget ? `${className} addNewTarget`:className;
			return (<Container
				tabIndex='0'
				className={className}
				data-id={item.getId()}
				aria-label={name}
				title={name}>
				<TruncatedText className="visJumpToView-item-content" value={name} location='end'/>
			</Container>);

		}

		render() {
			return (<Container className='visJumpToView'>
				<Container className='visJumpToView-container'>
					<List
						length={this.state.targets.length}
						itemRenderer={this._itemRenderer.bind(this)}
						fullHeight='true'
					/>
				</Container>
			</Container>);
		}
	}

	JumpToViewComponents.propTypes = {
		content: PropTypes.object,
		dashboard:PropTypes.object,
		sourceId: PropTypes.string,
		jumpToTargets: PropTypes.array,
		isDataPointSelection: PropTypes.bool,
		scopedPageContext: PropTypes.object
	};

	return JumpToViewComponents;

});
